<div class="card shadow-sm rounded-3">
  <div class="card-body py-2">
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="fw-bold text-dark m-0">
        <i class="la la-bolt me-2"></i> {{ 'ENERGY.ENERGY_DATA' | translate }}
      </h4>
      <!--        <button (click)="inProcess()" class="btn btn-primary btn-sm py-2">-->
      <!--          <i class="las la-plus me-1"></i> {{ 'PROPERTY.ADD_CONTRACTS' | translate }}-->
      <!--        </button>-->
    </div>
    <p class="text-muted mt-1 mb-0">{{ 'ENERGY.ENERGY_DESCRIPTION' | translate }}</p>
    <div class="row mt-4">
      <div class="col-12 col-md-6 col-lg-4">
        <div class="fw-bolder">{{ 'ENERGY.ENERGY_CLASS' | translate }}</div>
        <p class="text-muted">{{ energyContracts.energyClass }}</p>
      </div>

      <div class="col-12 col-md-6 col-lg-4">
        <div class="fw-bolder">{{ 'ENERGY.HEATING_TYPE' | translate }}</div>
        <p class="text-muted">{{ energyContracts.heatingType }}</p>
      </div>

      <div class="col-12 col-md-6 col-lg-4">
        <div class="fw-bolder">{{ 'ENERGY.PRIMARY_ENERGY_CONSUMPTION' | translate }}</div>
        <p class="text-muted">{{ energyContracts.primaryEnergy }}</p>
      </div>

      <div class="col-12 col-md-6 col-lg-4">
        <div class="fw-bolder">{{ 'ENERGY.FINAL_ENERGY_CONSUMPTION' | translate }}</div>
        <p class="text-muted">{{ energyContracts.finalEnergy }}</p>
      </div>

      <div class="col-12 col-md-6 col-lg-4">
        <div class="fw-bolder">{{ 'ENERGY.ENERGY_CERTIFICATE_FROM' | translate }}</div>
        <p class="text-muted">{{ energyContracts.energyCertificate }}</p>
      </div>
      <div class="text-start">
        <button class="btn btn-outline-primary btn-sm">
          <i class="pi pi-eye"></i> {{ 'ENERGY.EDIT_DATA' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
